import * as utility from '../misc/utility';
import type { ApiService } from './ApiService';
import { FileInfo } from '../objects/FileInfo';
import _ from 'lodash';

export enum OwnerType {
    Meeting,
    Person,
    Organization,
}

export interface IFileCmdBase {
    OwnerId: string;
    OwnerType: OwnerType;
}

export interface IListFilesCmd extends IFileCmdBase {
}

export interface IUploadFile extends IFileCmdBase {
    FilePath: string;
    Replace: boolean;
    File: File;
}

export interface ICreateFolderCmd extends IFileCmdBase {
    Path: string;
}

export interface IUpdateMultipleFilesCmd extends IFileCmdBase {
    FileIds: string[];
    ShowPolitiker: boolean|null|undefined;
    ShowPublik: boolean|null|undefined;
}

export interface IDeleteFilesCmd extends IFileCmdBase {
    FileIds: string[];
}

export interface IMoveFilesCmd extends IFileCmdBase {
    TargetFolder: string|null;
    FileIds: string[];
    RenameIfExists: boolean;
}

export interface IUpdateSingleFileCmd extends IFileCmdBase {
    FileId: string;
    Name: string;
    ShowPolitiker: boolean;
    ShowPublik: boolean;
}

export class FileEndpoint {
    private url: string;
    private _api: ApiService;
    
    constructor(url: string, api: ApiService) {
        this.url = url;
        this._api = api;
    }

    downloadAttachment(id: string) {
        if (!utility.isGuid(id)) throw "Invalid parameter, expected GUID";

        var dst = this.url + '/attachment/' + encodeURIComponent(id);
        return this._api.getDownload(dst);
    }

    listFiles(cmd: IListFilesCmd) {
        var dst = this.url + '/list';
        return this._api.postResponse(dst, cmd)
            .then(rsp => _.map(rsp.getResult(), x => new FileInfo(x)));
    }

    uploadFile(cmd: IUploadFile, signal?: AbortSignal) {
        const data = new FormData();
        data.set('OwnerId', cmd.OwnerId);
        data.set('OwnerType', cmd.OwnerType.toString());
        data.set('Replace', cmd.Replace ? "true" : "false");
        data.set('FilePath', cmd.FilePath);
        data.set('File', cmd.File);
        data.set('ModifiedTimestamp', new Date(cmd.File.lastModified).toISOString());

        const init: RequestInit = {
            method: 'POST',
            headers: {},
            body: data,
            signal: signal,
        };

        return this._api.authenticatedFetch(this.url + '/upload', init);
    }

    createFolder(cmd: ICreateFolderCmd) {
        var dst = this.url + '/folder';
        return this._api.postVoid(dst, cmd);
    }

    updateMultipleFiles(cmd: IUpdateMultipleFilesCmd) {
        var dst = this.url + '/updatemultiple';
        return this._api.postVoid(dst, cmd);
    }

    updateSingleFile(cmd: IUpdateSingleFileCmd) {
        var dst = this.url + '/update';
        return this._api.postVoid(dst, cmd);
    }

    deleteFiles(cmd: IDeleteFilesCmd) {
        var dst = this.url + '/delete';
        return this._api.postVoid(dst, cmd);
    }

    moveFiles(cmd: IMoveFilesCmd) {
        var dst = this.url + '/move';
        return this._api.postVoid(dst, cmd);
    }
}
